var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.99 15.9908L14.05 11.0508L11.93 13.1708L16.87 18.1108C17.46 18.7008 18.41 18.7008 18.99 18.1108C19.57 17.5208 19.57 16.5708 18.99 15.9908Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 8.00078C17.58 8.00078 19.15 6.43078 19.15 4.50078C19.15 3.92078 18.99 3.38078 18.74 2.90078L16.04 5.60078L14.55 4.11078L17.25 1.41078C16.77 1.16078 16.23 1.00078 15.65 1.00078C13.72 1.00078 12.15 2.57078 12.15 4.50078C12.15 4.91078 12.23 5.30078 12.36 5.66078L10.51 7.51078L8.73 5.73078C9.12 5.34078 9.12 4.71078 8.73 4.32078L8.02 3.61078L10.14 1.49078C8.97 0.320781 7.07 0.320781 5.9 1.49078L3.08 4.32078C2.69 4.71078 2.69 5.34078 3.08 5.73078L3.79 6.44078H1.25C1.06 6.44078 0.880001 6.51078 0.750001 6.65078C0.470001 6.93078 0.470001 7.37078 0.750001 7.65078L3.29 10.1908C3.57 10.4708 4.01 10.4708 4.29 10.1908C4.42 10.0608 4.5 9.88078 4.5 9.69078V7.15078L5.2 7.85078C5.59 8.24078 6.22 8.24078 6.61 7.85078L8.39 9.63078L2.04 15.9808C1.45 16.5708 1.45 17.5208 2.04 18.1008C2.63 18.6908 3.58 18.6908 4.16 18.1008L14.48 7.79078C14.85 7.92078 15.24 8.00078 15.65 8.00078Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.a283de5b0a6f1ac0752cb0dc60f1768c.svg";
export { ForwardRef as ReactComponent };